import $ from 'jquery'
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import moment from 'moment'
extend("required", {
  ...required,
  message: "Ce champ est obligatoire !",
});

export default {
    name: 'modal-traiter-conduite',
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        conduite: Object, // protocole de soins sélectionnés
        conduite_moment: Object
    },
    data () {
        return {
            user_id: 0,
            loading: false,
            a_traite: null,
            user_role: '',
            active_role: '',
            constantes:{
                temperature: null,
                tension_arterielle: null,
                
                pouls: null
            },
        }
    },
    computed: {

        activeRole() {
            return this.$store.getters['activeRole'];
        },
        /**
         * User Info
         * @returns 
        */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        canAddConstantes() {
            if (
                this.properJson(this.conduite.constantes).temperature == false && this.properJson(this.conduite.constantes).tension == false && 
                this.properJson(this.conduite.constantes).tension == false
            ) {
                return false
            } else {
                return true
            }
        }
    },
    mounted () {
        this.user_id = this.userCredentials.id        
    },
    methods: {
        properJson(data){
            try {
               return JSON.parse(data)
            } catch(e){
                return data

            }
        },

        formatHour: function(date){
            let formattedDate = moment(date)

            return formattedDate.format('HH:mm');
        },

        /**
         * Ajoute le caractère slash (/) après n chiffres
         * @param {*} n 
         * @param {} selector (est l'ID du champ input)
         */
        async formatNumberToSlash(n, selector) {
            let nb_car = $('#' + selector).val().length;
            if (n == '1') {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9m ]+/g, ''))

                if (nb_car == n) {
                    $('#' + selector).val($('#' + selector).val() + 'm ');
                }
            } else if (n == '2') {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9^C°]+/g, ''))

                if (nb_car == n) {
                    $('#' + selector).val($('#' + selector).val() + '°');
                }else if (nb_car == 4) {
                    $('#' + selector).val($('#' + selector).val() + 'C');
                }
                this.constantes.temperature = $('#' + selector).val()
            }  else if (n == '3') {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9/]+/g, ''))

                if (nb_car == 2) {
                    $('#' + selector).val($('#' + selector).val() + '/');
                }
            }
        },
        // async formatNumberToSlash(n, selector) {
        //     let nb_car = $('#'+selector).val().length;
        //     if (n == '1') {
        //         $('#'+selector).val( $('#'+selector).val().replace(/[^0-9m ]+/g, '') )

        //         if(nb_car == n) {
        //             $('#'+selector).val($('#'+selector).val()+'m ');
        //         }
        //     } else {
        //         $('#'+selector).val( $('#'+selector).val().replace(/[^0-9/]+/g, '') )

        //         if(nb_car == n) {
        //             $('#'+selector).val($('#'+selector).val()+'/');
        //         }
        //     }
            
        // },

        /**
         * Format input to only digit
         * @param {*} selector 
         */
        async onlyDigit(selector) 
        {
            $('#'+selector).val( $('#'+selector).val().replace(/[^0-9]+/g, '') )
        },

        onConfirm()
        {
            $('.err-msg').fadeOut(500);
        },

        clearAll(index, selector) {

            $('#' + selector).val('')
            if (index == '1') {
                this.constantes.taille = ''
            } else if (index == '2') {
                console.log("s: ", selector)
                this.constantes.temperature = ''
            } else if (index == '3') {
                this.constantes.tension_arterielle = ''
            }
        },

        /**
         * Enregistrer le traitement
         * @param {*} catID 
         */
        traiterCAT(catID)
        {

            this.loading = true;
            this.$refs.constante_form.validate().then((success) => {
                if (!success) {
                    this.loading = false;
                    console.log("--> Error");
                    return;
                }

                let confirm = document.getElementById('confirm'+catID);
                let err = 0;
                if (confirm.checked == false) {     //  Vérifie si l'utilisateur a confirmé avoir effectuer le traitement
                    $('.err-msg').fadeIn(500)
                    err++;
                    this.loading = false;
                }

                if(err == 0) {
                    let data = {};
                    data = {
                        "user_id": this.user_id,
                        "temperature": this.constantes.temperature ,
                        "tension": this.constantes.tension_arterielle,
                        "pouls": this.constantes.pouls,
                        "consultation_id": this.conduite.consultation_id,
                        "protocole_id": this.conduite.id,
                        "jour_id": this.conduite.jour_id
                    }

                    console.log(data)

                    this.$store.dispatch('storeCatConstante', data).then(
                        () => {
                            console.log("--> success",data)
                            this.loading= false;
                            // Reset form
                            this.conduite.temperature = ''
                            this.conduite.tension_arterielle = ''
                            this.conduite.pouls = ''

                            let d = new Date()
                            let dd = (d.getDate() <= 9) ? '0' + d.getDate() : d.getDate();
                            let mm = ((d.getMonth() + 1) <= 9) ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
                            let y = d.getFullYear();

                            let d_date = y + '-' + mm + '-' + dd;

                            if(this.activeRole.nom ==='ROLE_SAGE_FEMME'){
                                this.$store.dispatch('getSoinsCPN', {  date_cat: d_date }).then((response) => {
                                    this.liste_conduites = response
                                    console.log("Liste des cat : ", this.currentCAT)
                                });
                            } else{
                                this.$store.dispatch('getCurrCat', { consultation_id: 0, date_cat: d_date })
                            }

                            $('.modal').modal('hide');
                        }
                    ).catch(
                        error =>{
                            this.loading = false;
                            console.log(error);
                        }
        
                    )
                }
            });
        }
    }
}